import { AudioSourceTypes } from '../../../enums/AudioSourceTypes';

/**
 * @public
 */
export interface StartRecognizeRequestBody {
  audioSource?: AudioSourceTypes;
}
